import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchCorpCodesArgs } from '../api/types/corpCodes.types';

import { fetchCorpCodes } from '../api/corpCodes.api';

export const corpCodesQueryKeys = createQueryKeys('corpCodes', {
  fetchCorpCodes: ({ corpOrganizationId, filters }: FetchCorpCodesArgs) => ({
    queryFn: () => fetchCorpCodes({ corpOrganizationId, filters }),
    queryKey: [corpOrganizationId, filters],
  }),
});
